module.exports = __webpack_public_path__ + "static/media/trekspresso-logo.1a6033e8.jpg";